import {
  HttpContext,
  HttpContextToken,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { WorkflowOrderService } from '../services/workflow-order.service';

/** The order a write changes, for URLs that do not carry it (order items). */
export const ORDER_ID = new HttpContextToken<string | number | null>(() => null);

/** A write's context naming the order it changes (none: the interceptor drops every order) */
export const orderContext = (orderId: string | number | null | undefined) =>
  new HttpContext().set(ORDER_ID, orderId ?? null);

/** /orders/orders/{id}/..., /orders/workflow/orders/{id}/... and /payments/orders/{id}/... */
const ORDER_URL = /\/(?:orders\/(?:workflow\/)?orders|payments\/orders)\/(\d+)\//;
/** Any other write of the orders app (an item with no order id, a new order) */
const ORDERS_APP_URL = /\/orders\//;
/** A write to a quote changes its order too (the proforma's approval and send, the workflow), unnamed in the URL */
const QUOTES_URL = /\/procurement\/quotes\//;

/**
 * The one place the cached copy of an order is dropped: after any write that
 * changed it succeeds, whichever service or component sent it.
 */
export const orderCacheInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method === 'GET') return next(req);
  const orders = inject(WorkflowOrderService);
  return next(req).pipe(
    tap((event) => {
      if (!(event instanceof HttpResponse)) return;
      const id = req.context.get(ORDER_ID) ?? req.url.match(ORDER_URL)?.[1];
      if (id) orders.invalidateOrder(id);
      else if (ORDERS_APP_URL.test(req.url) || QUOTES_URL.test(req.url)) orders.invalidateAll();
    })
  );
};
